// @ts-check
export const PAYERS_REQUESTED = 'PAYERS_REQUESTED';
export const PAYERS_RECEIVED = 'PAYERS_RECEIVED';
export const PAYER_PLANS_REQUESTED = 'PAYER_PLANS_REQUESTED';
export const PAYER_PLANS_FETCHING = 'PAYER_PLANS_FETCHING';
export const PAYER_PLANS_RECEIVED = 'PAYER_PLANS_RECEIVED';

export function payerPlansRequested(payerId) {
  return { type: PAYER_PLANS_REQUESTED, payerId };
}

export function payerPlansFetching(payerId) {
  return { type: PAYER_PLANS_FETCHING, payerId };
}

export function payerPlansReceived(payerId, plans) {
  return {
    type: PAYER_PLANS_RECEIVED,
    payerId,
    plans,
  };
}

export function payersRequested() {
  return { type: PAYERS_REQUESTED };
}

export function payersReceived(payers) {
  return {
    type: PAYERS_RECEIVED,
    payers,
  };
}
